import request from '../utils/request';
import { DictionaryDto, PagedView } from './dictionary';

export function initRejectReason(): RejectReasonDto {
    return {
        code: '',
        description: '',
        id: '',
        priority: '',
        status: 'ACTIVE',
    };
}

export interface RejectReasonDto extends DictionaryDto {
    priority: number | string;
    products?: DictionaryDto[];
}

export function deactivateReason(id: number | string, status: string) {
    return request(`/reject-reason/by-id/${id}/${status}`, {
        method: 'PUT',
    });
}

export function fetchRejectProducts() {
    return request('/product/list', {
        method: 'GET',
    }).then(({ data }) => data as PagedView<DictionaryDto>);
}
